export * from "./components/GameObjectForm";

async function fetchData(): Promise<any> {
    try {
        const response: Response = await fetch(viteConfiguration.API_URL);
        return await response.json();
    } catch (error) {
        console.error("Error calling API:", error);
    }
}

const data: any = await fetchData();
console.log(data);



export { };

